import { Routes } from '@angular/router';
import { RoleGuard } from './services/auth/guards/role.guard';
import { canActivateGuard } from './services/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
     loadComponent: () =>
      import('./components/auth/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/admin/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [RoleGuard, canActivateGuard],
    data: { roles: ['Personal', 'Admin'] },
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' }
];
